import { COLORS, MaterialIcons } from '@monthio/react-components'
import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

const Icon = styled.div<{ $color?: string }>`
	${(props) => props.theme.breakpoints.down('xs')} {
		padding-left: 3px;
	}

	${(props) => props.theme.breakpoints.up('sm')} {
		padding-left: 15px;
	}

	${(props) => props.theme.breakpoints.up('lg')} {
		padding-left: 22px;
	}

	> svg {
		color: ${(props) => props.$color ?? COLORS.PRIMARY};
		height: 100%;
	}
`

interface ExpandedIconProps {
	expanded: boolean
	color?: string
}

export const ExpandIcon: FunctionComponent<ExpandedIconProps> = ({
	expanded,
	color,
}) => {
	if (expanded) {
		return (
			<Icon $color={color}>
				<MaterialIcons.KeyboardArrowUpRounded />
			</Icon>
		)
	}
	return (
		<Icon $color={color}>
			<MaterialIcons.KeyboardArrowDownRounded />
		</Icon>
	)
}
